module.exports = __webpack_public_path__ + "static/media/home_auth_popup.0283dd58.svg";